import { getFullDate, getShortDate } from 'utils/utils';

import { useSectionVisible } from 'appContainer/SectionVisible';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import Paper from 'styles/paper/paper';
import Stack from 'styles/stack/Stack';
import CompositeTypography from 'styles/typography/CompositeTypography.styles';
import { SECTIONS } from 'types/SectionsVisibility';
import { useTranslation } from 'utils/translations';

const MemberDetail: FC = () => {
	const { member } = useSelector((store: RootState) => store.member);
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});

	const showPPS = useSectionVisible(SECTIONS.PPS_CODE, {
		customLayout: member?.carrier.customLayout || null,
	});

	return (
		<Paper
			elevation={0}
			sx={{
				p: 2.5,
				width: '100%',
				justifyContent: 'space-between',
				display: 'flex',
				borderRadius: 0.5,
			}}
		>
			<Stack flexGrow={1} rowGap={1.875}>
				<CompositeTypography
					label={tClientLabels('memberDetail.labels.memberName')}
					value={member?.memberName ? member?.memberName : '-'}
				/>
				<CompositeTypography
					label={tClientLabels('memberDetail.labels.carrier')}
					value={member?.carrier ? member?.carrier.carrierName : '-'}
				/>
				<CompositeTypography
					label={tClientLabels('memberDetail.labels.dateOfService')}
					value={getShortDate(member?.dateOfService)}
				/>
			</Stack>
			<Stack flexGrow={0} width={'50%'} rowGap={1.875}>
				<CompositeTypography
					label={
						showPPS
							? tClientLabels('memberDetail.labels.pps')
							: tClientLabels('memberDetail.labels.fiscalCode')
					}
					value={member?.fiscalCode ? member?.fiscalCode : '-'}
				/>
				<CompositeTypography
					label={tClientLabels('memberDetail.labels.groupName')}
					value={member?.groupName ? member?.groupName : '-'}
				/>
				<CompositeTypography
					label={tClientLabels('memberDetail.labels.dateGenerated')}
					value={getFullDate(member?.dateGenerated)}
				/>
			</Stack>
		</Paper>
	);
};

export default MemberDetail;
